import * as Types from "../constants/actionTypes";
import { toast } from "react-toastify";

export const showToastAlert = (comment, options) => (dispatch) => {
  dispatch({
    type: Types.SHOW_TOAST_ALERT,
  });
  toast(comment, options);
};
